import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {isMobile} from 'react-device-detect';

const SimNumberHelper = (props) => {
  const sim = isMobile ? require('../icons/simcard_mobile.svg') : require('../icons/simcard.svg');
  return (
    <div className='device-supports-eSIM-popup'>
      <div className='device-supports-eSIM-popup-title'>מספר ה-SIM מופיע בגב הכרטיס, ממש כאן</div>
      <Image src={sim} />
    </div>
  );
};

export default SimNumberHelper;
